import { WebProtocol } from 'src/constants/web';

export const isWebProtocol = (protocol: string): protocol is WebProtocol =>
  protocol === WebProtocol.HTTP || protocol === WebProtocol.HTTPS;
